"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareEvent = void 0;
var ShareEvent;
(function (ShareEvent) {
    ShareEvent["COPY_LINK"] = "COPY_LINK";
    ShareEvent["INTERNAL_SHARE"] = "INTERNAL_SHARE";
    ShareEvent["EXTERNAL_SHARE"] = "EXTERNAL_SHARE";
})(ShareEvent = exports.ShareEvent || (exports.ShareEvent = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbWlzYy90eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUF1QkEsSUFBWSxVQUlYO0FBSkQsV0FBWSxVQUFVO0lBQ3BCLHFDQUF1QixDQUFBO0lBQ3ZCLCtDQUFpQyxDQUFBO0lBQ2pDLCtDQUFpQyxDQUFBO0FBQ25DLENBQUMsRUFKVyxVQUFVLEdBQVYsa0JBQVUsS0FBVixrQkFBVSxRQUlyQiJ9